import { VideoPlatform } from '../integration-provider';
import { TextTrackMimeType } from '../../core/player/text-track-mime-type';
import { StreamingProtocol } from '../../core/player/playout-data';
import { CvsdkError, ErrorSeverity } from '../../error';
import { VTT_TEXT_MIMETYPES } from '../../players/player-extensions/subtitles/subtitles-utils';
import { JsonUtils } from '../../utils/json-utils';
import { TextRole } from '../../core/player/role';
var NO_CONTENT = 'No Content URL';
export function playoutResponseAdapter(playlist, sessionItem) {
    var cdns = playlist.clips.map(function(clip) {
        return {
            url: clip.URL,
            name: VideoPlatform.SMIL
        };
    });
    var protocol = getStreamingProtocol(playlist.clips);
    var extTracks = getExternalTracks(playlist.clips);
    var adaptedData = {
        // Depend on the application
        autoplay: sessionItem.autoplay,
        advertising: {
            contentId: cdns.length > 0 ? cdns[0].url : NO_CONTENT
        },
        muted: sessionItem.muted,
        preferredAudioMetadata: sessionItem.preferredAudioMetadata,
        preferredAudioLanguages: sessionItem.preferredAudioLanguages,
        preferredSubtitleMetadata: sessionItem.preferredSubtitleMetadata,
        preferredSubtitlesLanguages: sessionItem.preferredSubtitlesLanguages,
        playerBitrateLimits: sessionItem.playerBitrateLimits,
        type: sessionItem.type,
        cdns: cdns,
        stream: {
            protocol: protocol
        },
        containsMandatoryPinEvents: false,
        abrConfiguration: sessionItem.abrConfiguration,
        position: sessionItem.startPosition || 0,
        externalTracks: extTracks,
        vamPrerollEnabled: true,
        vamMidrollEnabled: true,
        // From SDK itself
        sessionId: sessionItem.sessionId
    };
    return adaptedData;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Error is always any or unknown when caught
export function playoutDataErrorAdapter(e) {
    var _e_response, _e_response1;
    return CvsdkError.from({
        code: e.code || ((_e_response = e.response) === null || _e_response === void 0 ? void 0 : _e_response.status) && "SMIL_HTTP_".concat(e.response.status) || 'SDK_VPI_FAILURE',
        message: e.description || ((_e_response1 = e.response) === null || _e_response1 === void 0 ? void 0 : _e_response1.statusText) || e.message || JsonUtils.stringify(e),
        severity: ErrorSeverity.Fatal,
        cause: e
    });
}
export function playerErrorAdapter(e) {
    return e;
}
/**
 * Loops over the clip types, choosing DASH if it's found, defaulting to HLS if not
 * @param clips List of the content to be played
 * @returns Streaming Protocol found or defaults to HLS
 */ function getStreamingProtocol(clips) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = clips[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var clip = _step.value;
            var _clip_type;
            if ((_clip_type = clip.type) === null || _clip_type === void 0 ? void 0 : _clip_type.includes('application/dash')) {
                return StreamingProtocol.DASH;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return StreamingProtocol.HLS;
}
/**
 * Extracts external tracks from the parsed SMIL data
 * @param clips List of content to be played
 * @returns Array of external tracks to be loaded later
 */ function getExternalTracks(clips) {
    var tracks = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = clips[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var clip = _step.value;
            var _clip_availableTextTracks;
            var _clip_availableTextTracks_filter;
            var newTracks = (_clip_availableTextTracks_filter = (_clip_availableTextTracks = clip.availableTextTracks) === null || _clip_availableTextTracks === void 0 ? void 0 : _clip_availableTextTracks.filter(function(track) {
                return VTT_TEXT_MIMETYPES.includes(track.MIMEType);
            })) !== null && _clip_availableTextTracks_filter !== void 0 ? _clip_availableTextTracks_filter : [];
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = newTracks[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var track = _step1.value;
                    // Only set once
                    if (!tracks.has(track.URL)) {
                        tracks.set(track.URL, {
                            uri: track.URL,
                            id: track.URL,
                            language: track.language,
                            roles: [
                                TextRole.Subtitle
                            ],
                            // This is currently always Subtitle
                            mimeType: TextTrackMimeType.WebVTT
                        });
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // This is currently always WebVTT
    return Array.from(tracks.values());
}

//# sourceMappingURL=smil-data-adapters.js.map